import { axiosPrivate } from "./AxiosPrivate";

//Dashboard

export const getDashboard = () => axiosPrivate.get("/manager/get-dashboard");

//Settings

export const updateManagerGeneral = (data) =>
  axiosPrivate.put("/manager/update-manager", data);

export const updateManagerNotification = (data) =>
  axiosPrivate.put("/manager/update-notification", data);

export const managerChangePassword = (data) =>
  axiosPrivate.put("/manager/change-password", data);
